<script>
export default {
  props: {
    soalStats: Object,
    listItem: Object,
    getQuestionNumber: Function,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    // Jawaban
    isBooleanQuestion: Boolean,
    // currentQuestion: Object,
    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    // navigasi
    // currentQuestion: Object,
    isLastQuestion: Boolean,
    isAllAnswered: Boolean,
    openProgressFinal: Function,
    nextQuestion: Function,
    // is_instruksi: Number,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    // mengerjakan: Function,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      abjad : ["A", "B", "C", "D"],
    };
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- NUMBER -->
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          Soal
          <span class="mym-actived-number">{{ index_soal }}</span> /
          {{ soalStats.total }}
        </div>
      </div>

      <div class="mym-question-section">
        <div class="mb-2">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div class="mym-options" :class="{ 'grid-mode': hasImageOptions }">
        <div
          v-for="(jawaban, i) in currentQuestionShuffleOptionList"
          :key="i"
          class="mym-option-card"
          :class="{ active: jawaban.selected }"
          @click="selectAnswer(currentQuestion, jawaban)"
        >
          <!-- @click="localAnswers[currentIndex] = opt.kode_jawaban" -->

          <img v-if="jawaban.image" :src="jawaban.image" class="option-image" />

          <div class="option-content">
            <div class="option-label">
              <span v-if="jawaban.selected">✔</span>
              <!-- <span v-else>{{ jawaban.kode_jawaban }}</span> -->
              <span v-else>{{ abjad[i] }}</span>
            </div>

            <div class="option-text">
              {{ jawaban.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="mym-footer justify-content-end">
      
      <button
        v-if="last_page - 1 !== index_soal && status_pengerjaan === 0"
        class="mym-btn mym-bg-primary"
        type="button"
        @click="nextSoal(1)"
      >
        Selanjutnya
        <i class="fas fa-chevron-right ms-1"></i>
      </button>

      <button
        v-if="last_page - 1 === index_soal || status_pengerjaan === 1"
        class="mym-btn mym-bg-success"
        type="button"
        @click="$emit('modalProgressFinal')"
        style="width: 200px"
      >
        Selesai
        <i class="fas fa-check ms-1"></i>
      </button>
    </div>
  </div>
</template>